<script lang="ts">
  import Link from '#app/lib/components/link.svelte'
  import { icon } from '#app/lib/icons'
  import { getTranslatedLanguagesData } from '#app/lib/languages/languages'
  import log_ from '#app/lib/loggers'
  import { translate } from '#app/lib/urls'
  import Dropdown from '#components/dropdown.svelte'
  import { getCurrentLang, I18n, i18n } from '#user/lib/i18n'
  import { mainUser, updateUser, setNewLanguage } from '#user/lib/main_user'
  import Spinner from './spinner.svelte'

  const currentLang = getCurrentLang()

  const translatedLanguages = [
    { lang: 'ca', label: 'Valencià', completion: 100 },
    { lang: 'es', label: 'Castellano', completion: 100 },
    { lang: 'en', label: 'English', completion: 100 }
  ]

  const currentLanguageLabel = translatedLanguages
    .find(langInfo => langInfo.lang === currentLang)?.label

  function selectLang (lang) {
    if (mainUser) updateUser('language', lang)
    else setNewLanguage(lang)
  }
</script>

<div class="language-picker">
  <Dropdown dropdownWidthBaseInEm={18}>
    <div slot="button-inner">
      <span class="current-lang-label">{currentLanguageLabel}</span>
      <span class="current-lang">{currentLang}</span>
      {@html icon('caret-down')}
    </div>
    <div slot="dropdown-content">
      <ul class="options">
        {#each translatedLanguages as { lang, label, completion } (lang)}
          <li class="option">
            <button
              title="{i18n('switch_to_lang', { language: label })}"
              on:click={() => selectLang(lang)}
            >
              <span class="lang-label">{label}</span>
            </button>
          </li>
        {/each}
      </ul>
    </div>
  </Dropdown>
</div>

<style lang="scss">
  @import "#general/scss/utils";
  .language-picker{
    margin-inline-start: 0.2em;
    align-self: stretch;
    @include display-flex(row, stretch, center);
    :global(.dropdown-button){
      @include bg-hover-lighten-svelte($topbar-bg-color);
      padding-inline-start: 0.5em;
    }
    :global(.fa-caret-down){
      color: #ccc;
    }
    :global(.spinner){
      width: 4rem;
      @include display-flex(row, center, center);
    }
  }
  [slot="button-inner"]{
    @include serif;
    font-weight: bold;
    color: white;
    white-space: nowrap;
    span{
      color: white;
    }
  }
  .options{
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 60vh;
  }
  li.option{
    @include display-flex(row, stretch);
    button{
      flex: 1 0 auto;
      padding: 0.4em 0;
      position: relative;
      z-index: 1;
      background-color: $grey;
      border-radius: 0;
      text-align: start;
      @include display-flex(row);
      &, span{
        color: white;
      }
      &:focus{
        background-color: $dark-grey;
      }
    }
    .lang-label{
      font-weight: bold;
      margin-inline: 0.5rem 0.2rem;
    }
  }
  .current-lang{
    display: none;
  }
</style>
